import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { CONTACT } from "@/data/content";
import Logo from "@/components/Logo";

const SiteFooter = ({ onNavigate }) => {
  const { t } = useLang();
  const year = new Date().getFullYear();

  const links = [
    { id: "azienda", label: t("tabs.azienda") },
    { id: "servizi", label: t("tabs.servizi") },
    { id: "lavori:petrolifero", label: t("tabs.lavori") },
    { id: "certificazioni", label: t("tabs.certificazioni") },
    { id: "partner", label: t("tabs.partner") },
    { id: "contatti", label: t("tabs.contatti") },
    { id: "privacy", label: t("tabs.privacy") },
  ];

  return (
    <footer data-testid="site-footer" className="relative bg-forest-deep text-cream border-t border-cream/10">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-14 py-14">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <button onClick={() => onNavigate("home")} className="inline-flex"><Logo tone="light" /></button>
            <p className="text-cream/60 text-sm font-light italic mt-5 max-w-xs">{t("contact.builtWith")}</p>
          </div>

          <div className="md:col-span-3">
            <nav className="flex flex-col gap-2.5">
              {links.map((l) => (
                <button
                  key={l.id}
                  onClick={() => onNavigate(l.id)}
                  className="text-left text-sm text-cream/70 hover:text-gold transition-colors w-fit"
                >
                  {l.label}
                </button>
              ))}
            </nav>
          </div>

          <div className="md:col-span-4 space-y-3 text-sm">
            <a href={`https://maps.google.com/?q=${encodeURIComponent(CONTACT.address)}`} target="_blank" rel="noreferrer" className="flex items-start gap-3 text-cream/70 hover:text-gold transition-colors">
              <MapPin size={16} className="mt-0.5 shrink-0" /> <span>{CONTACT.address}</span>
            </a>
            <a href={CONTACT.phoneHref} className="flex items-center gap-3 text-cream/70 hover:text-gold transition-colors">
              <Phone size={16} /> {CONTACT.phone}
            </a>
            <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-cream/70 hover:text-gold transition-colors">
              <Mail size={16} /> {CONTACT.email}
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-cream/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 text-xs text-cream/40">
          <span>© {year} {CONTACT.companyName} — {t("contact.rights")}</span>
          <span>P. IVA {CONTACT.vat}</span>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
